@if (forms) {
  <div class="astral-stack-m">
    @for (form of $any(forms.controls); track form) {
      <section class="astral-section-surface astral-section-surface--compact">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input type="number" [control]="form.controls['mortgageOrder']"></astral-input>
          <astral-input [control]="form.controls['mortgageNumber']"></astral-input>
          <app-autocomplete-remote
            [service]="creditInstituteService"
            [control]="form.controls['creditInstituteId']"
            [defaultSearch]="'*'"
          ></app-autocomplete-remote>
          <astral-date-picker [control]="form.controls['fromDate']"></astral-date-picker>
          <astral-date-picker [control]="form.controls['toDate']"></astral-date-picker>
          <app-money-box class="astral-layout-item" [control]="form.controls['amount']"></app-money-box>
          <div class="astral-form-adjacent-action">
            <astral-button
              variant="secondary"
              size="small"
              type="button"
              icon="trash"
              labelKey="DELETE_BTN"
              (click)="delete(form)"
            ></astral-button>
          </div>
        </astral-layout-group>
      </section>
    }

    <astral-button
      variant="primary"
      size="small"
      type="button"
      icon="plus"
      labelKey="COOPERATIVE_HOUSING.ADD_MORTGAGE_PRESCRIPTION"
      (click)="addMortgage()"
    ></astral-button>
  </div>
}
